import { render } from "./PatientsFilter.vue?vue&type=template&id=7ef48dcc&scoped=true"
import script from "./PatientsFilter.vue?vue&type=script&lang=js"
export * from "./PatientsFilter.vue?vue&type=script&lang=js"

import "./PatientsFilter.vue?vue&type=style&index=0&id=7ef48dcc&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef48dcc"]])

export default __exports__